<template>
    <div v-if="gridColumns.length === 0" style="text-align: center; padding: 80px;">
        loading...
    </div>
    <div v-else>
        <!-- Grid -->
        <div class="grid_wrap">
            <!-- Grid "btn-->
            <div id="grid">
                <toast-grid
                    gridId="gridCmsModel"
                    :key="gridKey"
                    :data="gridData"
                    :columns="gridColumns"
                    :header="gridHeader"
                    :options="gridOptions"
                    :pageOptions="gridPageOptions"
                    :theme="gridTheme"
                    :isTotalCount="false"
                    v-bind:click="onGridCellClick"
                />
            </div>
        </div>
        <div class="paginate">
            <sdl-pagination
                :current-page="currentPage"
                :total-rows="resultCount"
                :per-page="perPage"
                @change="search"
                align="center"
            />
        </div>
    </div>

</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

import qs from 'query-string';

import { SDLUtil, DateUtil } from '@/utils';

import ToastGrid from '~c/ToastGrid';
import Pagination from '@/components/common/control/pagination/Pagination';

import { HeaderHtmlRenderer, } from '~c/GridCustomRenderer';

export default {
    components: {
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
    },
    props: {
        gubun: {
            type: String,
            required: true,
        },
        model: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            resultCount: 0,
            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridHeader: [],

            gridColumns: [],
            gridData: [],

            gridOptions: {
                scrollX: true,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            params: 'getParams',
        }),
    },
    created() {
        // console.log('CREATED');
        this.loadData();
    },
    mounted() {
        // console.log('MOUNTED');
    },
    methods: {
        async loadData() {
            const params = {
                gubun: this.gubun,
                model: this.model,
            };

            const formData = { 
                menuId: this.params.menuId,
            };

            const path = `/basis/common/cmsContents/cmsModelListSearch.skp?${qs.stringify(params)}`;

            SDLUtil.showLoadingBar(true);
            const data = await SDLUtil.postForm(path, formData);
            SDLUtil.showLoadingBar(false);

            this.resultCount = data.count;
            this.setGridHeader(data.header);
            this.setGridData(data.list);

            this.gridKey += 1;
        },

        async search(pageNo) {
            if (!this.validateForm()) return;

            const path = '/basis/common/cmsContents/cmsListSearch.skp?searchInfo=set';
            const formData = {
                menuId: this.params.menuId,
                page: pageNo || 1,
                inputModelCode: this.modelCode,
                ORDER_ASC: 'ASC',
                ORDER_FLAG: 'N',
            };
            SDLUtil.showLoadingBar(true);
            const data = await SDLUtil.postForm(path, formData);
            SDLUtil.showLoadingBar(false);

            this.resultCount = data.count;
            this.setGridHeader(data.header);
            this.setGridData(data.list);

            this.gridKey += 1;
        },

        setGridData(list) {
            this.gridData = list;
        },

        validateForm() {
            if (this.modelCode.length < 4) {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Please enter 4 or more characters for Model Code.',
                });
                return false;
            }
            return true;
        },

        setGridHeader(header) {
            this.gridHeader = {
                columns: header.map(item => {
                    return {
                        name: item.CONTENTS_CD,
                        renderer: HeaderHtmlRenderer,
                    };
                }),
            };

            const fixedColumns = [
                {
                    header: 'No.',
                    name: 'RNUM',
                    width: 60,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                // {
                //     header: 'Model',
                //     name: 'NMMODEL',
                //     width: 150,
                //     align: 'center',
                //     resizable: false,
                //     sortable: false,
                // },
                // {
                //     header: 'Model Code',
                //     name: 'CDMODEL',
                //     width: 150,
                //     align: 'center',
                //     resizable: false,
                //     sortable: false,
                // }
            ];

            this.gridColumns = [
                ...fixedColumns,
                ...header.map(item => {
                    let width = 110;
                    if (item.CONTENTS_DESC.toUpperCase().includes('SUBJECT')) {
                        width = null; // Free Size
                    }
                    return {
                        header: item.CONTENTS_DESC,
                        name: item.CONTENTS_CD,
                        width,
                        align: 'center',
                        className: 'cur_pointer',
                        resizable: false,
                        sortable: false,
                    };
                }),
            ];

        },



        async modelSearch(gubun, model) {
            const params = {
                gubun,
                model,
            };

            const formData = { 
                menuId: this.params.menuId,
            };

            const path = `/basis/common/cmsContents/cmsModelListSearch.skp?${qs.stringify(params)}`;
            const data = await SDLUtil.postForm(path, formData);
            console.log('DATA', data);
        },

        onGridCellClick(event, rowData) {
            console.log(event);
            if (typeof event.rowKey === 'undefined') return;
            const row = rowData[event.rowKey];
            // console.log('event rowKey', event.rowKey);
            // console.log('event columnName', event.columnName);
            // console.log('event rowData', rowData);
            console.log('event row', rowData[event.rowKey]);

            this.selectModel(row.CTTID, row.NMPRODTYPE, row.NMPRODSUBTYPE);
        },

        selectModel(CTTID, nmProdType, nmProdSubType) {
            this.$emit('select-model', {
                CTTID, nmProdType, nmProdSubType,
            });
        },

    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/cmsContents/CmsModelSearch.vue